/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { icons } from '../../../../../assets';
import { pushGTMAnalytic } from '../../../../../modules/analytics/GoogleTagManager/GTMActions';
import GTMOperations from '../../../../../modules/analytics/GoogleTagManager/GTMOperations';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { IRouteParams } from '../../../../../routes/constants/routesConstants';
import { openMobileCash } from '../../../../Table/actions/tableActions';
import { TTableButtonsGetTranslation } from '../useTableFooterButtons';


const useTableFooterButtonMobileCash = (
    getTranslation: TTableButtonsGetTranslation,
) => {
    const { clientId } = useParams<IRouteParams>();

    const dispatch = useDispatch();

    return {
        className: 'table-footer__link link-mobileCash',
        dataName: 'mobileCash',
        icon: icons.mobileCashDeskIcon,
        id: AccessComponentKeyEnum.FooterButtonInvoiceRepayment,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonInvoiceRepayment),

        onClick: useCallback(() => {
            dispatch(openMobileCash({
                clientId,
                onApplyCallback: (prepaySum: string) => {
                    dispatch(pushGTMAnalytic({
                        operation: GTMOperations.navigation.popUpPrepaymentOperation(prepaySum),
                    }));
                },
                onErrorLoadCallback: (error: string) => {
                    dispatch(pushGTMAnalytic({
                        operation: GTMOperations.navigation.errorPrepaymentOperation(error),
                    }));
                },
                onSuccessLoadCallBack: (prepaySum: string) => {
                    dispatch(pushGTMAnalytic({
                        operation: GTMOperations.navigation.successfulPrepaymentOperation(prepaySum),
                    }));
                },
            }));
        }, [dispatch, clientId]),
    };
};

export default useTableFooterButtonMobileCash;
